import React from 'react';
import { Helmet } from 'react-helmet';
import { generateSoftwareApplicationSchema } from '../../../utils/seo';

const SoftwareApplicationSchema: React.FC = () => {
  const schema = generateSoftwareApplicationSchema();

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SoftwareApplicationSchema; 